/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pretty_Factual_Lamb_SingInputs */

const fr_pretty_factual_lamb_sing = /** @type {(inputs: Pretty_Factual_Lamb_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Pretty_Factual_Lamb_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pretty_factual_lamb_sing = /** @type {((inputs?: Pretty_Factual_Lamb_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pretty_Factual_Lamb_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pretty_factual_lamb_sing(inputs)
});